export class ProdutoFichaTecnica {
  public id: number;
  public id_produto: number;
  public titulo: string;
  public link: string;

  constructor() { }
}
